export default __webpack_public_path__ + "static/media/NEAS0004.34I-38773_-22690_0.694c930e.jpg";